<template>
  <div class="cause-contain">
      <div class="title">{{title}}</div>
      <div class="content">
          <div class="list line_bottom" v-for="(item,index) in caseList" :key="index" @click="checkFile(item.downloadUrl,item.fileName)">
              <div class="edge">
                <div class="text">{{item.fileName}}.{{item.fileType}}</div>
                <div class="pic">
                  <img v-if="item.fileType=='pdf'" src="../../../assets/appraise/ic_pdf.png"/>
                  <img v-if="item.fileType=='doc'" src="../../../assets/appraise/ic_doc.png"/>
                  <img v-if="item.fileType=='exl'" src="../../../assets/appraise/ic_exl.png"/>
                  <img v-if="item.fileType=='jpg' || item.fileType=='png'" :src="item.fileUrl" class="size-38"/>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
    export default {
        name: 'materialScience',
        props: {
            caseList: { type: Array },
            title: { type: String }
        },
        data () {
            return {

                // maxWidth: '24px'
            }
        },
        methods: {
            checkFile (url, name) {
                // const str = navigator.userAgent.toLowerCase();
                // const ver = str.match(/cpu iphone os (.*?) like mac os/);
                // if (!ver) {
                //     this.$toast('当前暂不支持预览附件')
                //     console.log('不是苹果')
                // } else {
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: url,
                        isFullScreen: 0,
                        setTitle: name,
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
                // }
            }
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
.cause-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title{
    height:20px;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:20px;
    margin-top: 24px;
  }
  .content{
    margin-top:12px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    .list{
      // border-bottom: solid 1px #EEEEEE;
      .edge{
        padding:16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .text{
          flex: 1;
          font-size:16px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          line-height:24px;
          color:rgba(51,51,51,1);
          text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            padding-right: 45px;
        }
        .pic{
          width:34px;
          height:38px;
        }
      }
    }
    .line_bottom:last-child::after{
      border-bottom: 0;
    }
  }
}
</style>
